/**
 * Attach Brands and models multiselects functionality.
 */
export default class BrandsAndModels {

  #dom = {};

  constructor(element) {
    this.#dom.element = element;
    //this.#dom.brandsSelect = element.querySelector('select#brands');
    window.multiselects['brands'].element.addEventListener('change', this.#onBrandChanges.bind(this));
  }

  /**
   * Called when a brand multiselect values changes
   * @param {Event} event - Event object
   */
  #onBrandChanges(event) {
    this.#showModels();
  }

  /**
   * Filters car models multiselect option groups depending what brands are selected.
   */
  #showModels() {

    const allBrands = window.multiselects['models']?.listAllGroupNames();
    const selectedBrands = window.multiselects['brands']?.getValue();

    if (Array.isArray(selectedBrands)) {
      if (selectedBrands.length === 0) {
        window.multiselects['models']?.unSelectAll(false);
        window.multiselects['models']?.disableMultiselect();
      } else {
        window.multiselects['models']?.enableMultiselect();
      }
    }

    allBrands?.forEach(brandSlug => {
      const show = selectedBrands.includes(brandSlug);
      window.multiselects['models'].toggleOptionGroup(brandSlug, show);
    });

  }

  /**
   * Initialize brands and models filters.
   */
  static init() {
    document.querySelectorAll('.filter-brands-and-models').forEach(el => {
      new BrandsAndModels(el);
    });
  }
}

